@if(loading){
<div class="loader-container">
  <div class="loader-bg"></div>
  <div [@loadingState]="loading ? 'loading' : 'idle'" class="loading-section">
    <div class="loader"></div>
    <p>{{text || 'Loading...'}}</p>
  </div>
</div>
}
